import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal, Signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BasicPage } from '../../../../models';
import { HeaderComponent } from '../../../../components';
import { GtmClickDirective } from 'shared/src/directives';

@Component({
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, HeaderComponent, GtmClickDirective],
})
export class NotFoundPageComponent extends BasicPage {
  public override loading: Signal<boolean> = signal(false);

  constructor() {
    super();
  }
}
